import searchImage from "assets/images/searching.gif";

import styles from "./ErrorScreen.module.scss";

const ErrorScreen = ({ errorMessage }) => {
  return (
    <div className={styles.wrapper}>
      <img src={searchImage} alt="illustration" className={styles.image} />
      <p className={styles.text}>
        {errorMessage ?? "No RfQs available. Try again later."}
      </p>
    </div>
  );
};

export default ErrorScreen;
